import React, { useEffect, useState } from 'react';
import { Sidebar } from '../Sidebar';
import { Gheader } from '../Gheader';
import styles from './Roomorder.module.css';
import RoomTable from './RoomOrderTable';
import RoomModel from './RoomOrderModel';
import apiService from '../../api/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

export const Roomorder = () => {
  const hotelId = localStorage.getItem('hotel');
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [roomOrders, setRoomOrders] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [guests, setGuests] = useState([]);

  const addRoomOrder = newRoomOrder => {
    setRoomOrders([newRoomOrder, ...roomOrders]);
  };

  /* Fetching Rates from endpoint and updating local state */
  useEffect(() => {
    fetchRoomOrders();
    fetchGuests();
    fetchInventory();
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    try {
      const response = await apiService.get(`/rooms/?hotel=${hotelId}`);
      setRooms(response);
    } catch (error) {
      console.error('Error fetching Rooms:', error);
    } finally {
    }
  };

  const fetchRoomOrders = async () => {
    try {
      const response = await apiService.get(`/room-orders/?hotel=${hotelId}`);
      setRoomOrders(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchInventory = async () => {
    try {
      const response = await apiService.get(`/inventory/?hotel=${hotelId}`);
      setInventory(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGuests = async () => {
    try {
      const response = await apiService.get(`/guests/?hotel=${hotelId}`);
      setGuests(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3>Room Orders</h3>
          <div className={styles.buttonContainer}>
            <button
              className={styles.addRoomButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add order
            </button>
            {/* <FilterButton /> */}
          </div>

          <RoomTable
            data={roomOrders}
            setData={setRoomOrders}
            guests={guests}
            inventory={inventory}
            hotelId={hotelId}
            rooms={rooms}
          />

          {isModelOpen && (
            <RoomModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addRoomOrder}
              hotelId={hotelId}
            />
          )}
        </div>
      </div>

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default Roomorder;
